/**
 * Singleton class to manage global dimensions for metrics
 */
class GlobalDimensions {
  private static instance: GlobalDimensions;
  private dimensions: Record<string, string> = {};

  static getInstance(): GlobalDimensions {
    if (!GlobalDimensions.instance) {
      GlobalDimensions.instance = new GlobalDimensions();
    }
    return GlobalDimensions.instance;
  }

  addGlobalDimensions(dimensions: Record<string, string>): void {
    this.dimensions = { ...this.dimensions, ...dimensions };
  }

  getGlobalDimensions(): Record<string, string> {
    return { ...this.dimensions };
  }
}

export { GlobalDimensions };
